"use client";

import { Badge } from "@oreme/ui";
import { useAtom } from "jotai";
import { useLocale } from "next-intl";
import React, { type ReactElement } from "react";
import { selectedTagIdsAtom } from "@/store/sites";
import type { Tag } from "@/types";

interface SitesTagListProps {
  tags: Tag[];
}

function SitesTagList({
  tags,
}: Readonly<SitesTagListProps>): ReactElement | null {
  const locale = useLocale();
  const [selectedTagIds, setSelectedTagIds] = useAtom(selectedTagIdsAtom);

  const toggleTag = (id: number) => {
    setSelectedTagIds((prev) =>
      prev.includes(id) ? prev.filter((tagId) => tagId !== id) : [...prev, id],
    );
  };

  return (
    <ul className="flex flex-wrap max-w-[256px]">
      {tags.map((tag: Tag) => {
        const isActive = selectedTagIds.includes(tag.id);
        return (
          <li key={tag.id}>
            <button
              onClick={() => {
                toggleTag(tag.id);
              }}
              type="button"
            >
              <Badge
                className={`truncate ${isActive ? "text-white bg-blue-700" : ""}`}
              >
                {tag.name[locale]}
              </Badge>
            </button>
          </li>
        );
      })}
    </ul>
  );
}

export { SitesTagList, type SitesTagListProps };
